import { render } from "./SpinningWheel.vue?vue&type=template&id=ff526608&scoped=true"
import script from "./SpinningWheel.vue?vue&type=script&lang=js"
export * from "./SpinningWheel.vue?vue&type=script&lang=js"

import "./SpinningWheel.vue?vue&type=style&index=0&id=ff526608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff526608"]])

export default __exports__